import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import {BrowserRouter, Route, Routes} from 'react-router-dom'
import PrivateRoute from './ui/PrivateRoute';
import AdminRoute from './ui/AdminRoute';

import theme from './ui/Theme';
import Header from './ui/Header';
import LogoIntro from './ui/logo/LogoIntro';
import ErrorBoundary from './ui/ErrorBoundary';
import Login from './ui/login/Login';
import SignUp from './ui/login/SignUp';
import ForgotPassword from './ui/login/ForgotPassword';

import { AuthProvider, useAuth } from '../contexts/AuthContext';
import { DataProvider } from '../contexts/DataContext';
import MyPicks from './ui/myPicks/MyPicks';
import LandingPage from './ui/landing/LandingPage';
import Leaderboard from './ui/leaderboard/Leaderboard';
import { FAQ } from './FAQ';
import AdminPage from './ui/admin/AdminPage';
import GameManagement from './ui/admin/GameManagement';
import ScoringPage from './ui/admin/ScoringPage';
import TeamManagement from './ui/admin/TeamManagement';
import ApiUsage from './ui/admin/ApiUsage';
import UserManagement from './ui/admin/UserManagement';
import Profile from './ui/profile/Profile';
import TermsOfService from './ui/legal/TermsOfService';
import PrivacyPolicy from './ui/legal/PrivacyPolicy';
import SmsProgram from './ui/legal/SmsProgram';

function HomePage() {
	const { currentUser } = useAuth();
	return currentUser ? <MyPicks /> : <LandingPage />;
}

function App() {
	return (
		<AuthProvider>
			<ThemeProvider theme={theme}>
				<DataProvider>
					<BrowserRouter>
						<Header />
						<LogoIntro />
						<ErrorBoundary>
							<Routes>
								<Route path='/' element={<HomePage />}/>
								<Route path='/login' element={<Login/>}/>
								<Route path='/signup'element={<SignUp />}/>
								<Route path='/forgotpassword' element={<ForgotPassword/>}/>
								<Route path='/terms' element={<TermsOfService/>}/>
								<Route path='/privacy' element={<PrivacyPolicy/>}/>
								<Route path='/sms' element={<SmsProgram/>}/>
								<Route path='/leaderboard' element={<PrivateRoute component={Leaderboard}/>}/>
								<Route path='/faq' element={<PrivateRoute component={FAQ}/>} />
								<Route path='/profile' element={<PrivateRoute component={Profile}/>} />
								<Route path='/admin' element={<AdminRoute component={AdminPage}/>}>
									<Route path='games' element={<GameManagement />} />
									<Route path='scoring' element={<ScoringPage />} />
									<Route path='teams' element={<TeamManagement />} />
									<Route path='api-usage' element={<ApiUsage />} />
									<Route path='users' element={<UserManagement />} />
								</Route>
							</Routes>
						</ErrorBoundary>
					</BrowserRouter>
				</DataProvider>
			</ThemeProvider>
		</AuthProvider>
	);
}

export default App;
